import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DeviceGroupState, FEATURE_NAME } from './device-group.state';
import { selectDeviceState } from '../device.selectors';

export const selectDeviceGroupState =
  createFeatureSelector<DeviceGroupState>(FEATURE_NAME);

export const selectFilteredDeviceGroupsWithCurrentPage = createSelector(
  selectDeviceGroupState,
  (state: DeviceGroupState) => {
    if (
      state.filter?.page === null ||
      state.filter?.page === undefined ||
      !state.pages[state.filter.page]
    ) {
      return [];
    }

    return state.pages[state.filter.page].map((id) => state.entities[id]) ?? [];
  },
);

export const selectIsDeviceGroupsLoading = createSelector(
  selectDeviceGroupState,
  (state) => state.isLoading,
);

export const selectDeviceGroupFilter = createSelector(
  selectDeviceGroupState,
  (state) => state.filter,
);

export const selectDeviceGroupsTotalCount = createSelector(
  selectDeviceGroupState,
  (state) => state.totalCount,
);

export const selectDeviceGroupById = (id: string) =>
  createSelector(selectDeviceGroupState, (state: DeviceGroupState) =>
    Object.prototype.hasOwnProperty.call(state.entities, id)
      ? state.entities[id]
      : null,
  );

export const selectSortedDevicesByGroupId = (id: string) =>
  createSelector(
    selectDeviceGroupById(id),
    selectDeviceState,
    (deviceGroup, deviceState) =>
      [...(deviceGroup?.devices ?? [])]
        .map((device) => deviceState.entities[device.id] ?? device)
        .sort((a, b) => a.name.localeCompare(b.name)),
  );

export const selectAllDeviceGroups = createSelector(
  selectDeviceGroupState,
  (state: DeviceGroupState) => Object.values(state.entities),
);

export const selectFavoriteDeviceGroups = createSelector(
  selectDeviceGroupState,
  (state) =>
    Object.values(state.entities)
      .filter((deviceGroup) => deviceGroup.isFavorite)
      .sort((a, b) => a.name.localeCompare(b.name)),
);

export const selectDeviceGroupsByDevice = (deviceId: string) =>
  createSelector(selectAllDeviceGroups, (deviceGroups) =>
    deviceGroups
      .filter((group) =>
        group.devices?.some((device) => device.id === deviceId),
      )
      .sort((a, b) => a.name.localeCompare(b.name)),
  );

export const selectDeviceGroupExpandedById = createSelector(
  selectDeviceGroupState,
  (state: DeviceGroupState) => state.expandedById,
);

export const selectIsDeviceGroupExpanded = (id: string) =>
  createSelector(
    selectDeviceGroupExpandedById,
    (expandedById) => expandedById[id] === true,
  );
